import { type UUID } from '~/types/common';

import { useQueryUsersInfinite } from '~/data/user';

import { MultiItemsManager } from './MultiItemsManager';

const selectUsers = (data) =>
  data?.map(({ companyName, email, id }) => ({
    id,
    name: email,
    secondaryInfo: companyName,
  }));

type P = {
  readonly filterActive?: boolean | null;
  readonly isCreatingNewEntity?: boolean;
  readonly isDisabled?: boolean;
  readonly label?: string;
  readonly onChange?: (selectedIds: UUID[]) => void;
  readonly onSaveSelection?: () => void;
  readonly onSelectedItemClick?: (id: UUID) => void;
  readonly parentOrganizationalUnitId?: UUID;
  readonly parentUserGroupId?: UUID;
};

export const MultiItemsManagerUsers = ({
  filterActive = true,
  isCreatingNewEntity = false,
  isDisabled = false,
  label = 'Benutzer',
  onChange,
  onSaveSelection,
  onSelectedItemClick,
  parentOrganizationalUnitId,
  parentUserGroupId,
}: P) => {
  const useGetterFunctionSelectedItems = (searchString: string) => {
    const query = useQueryUsersInfinite({
      filterActive: filterActive ?? undefined,
      filterParentOu: parentOrganizationalUnitId ?? undefined,
      filterParentUserGroup: parentUserGroupId ?? undefined,
      searchString,
    });

    if (!isCreatingNewEntity) {
      return query;
    }

    return {
      data: [],
      fetchNextPage() {},
      hasNextPage: false,
      isFetchingNextPage: false,
      isLoading: false,
      totalCount: 0,
    };
  };

  const useGetterFunctionSelectableItems = (searchString: string) =>
    useQueryUsersInfinite({
      filterActive: filterActive ?? undefined,
      filterNotParentOu: parentOrganizationalUnitId ?? undefined,
      filterNotParentUserGroup: parentUserGroupId ?? undefined,
      searchString,
    });

  return (
    <MultiItemsManager
      fieldName="name"
      getterFunctionSelectableItems={useGetterFunctionSelectableItems}
      getterFunctionSelectedItems={useGetterFunctionSelectedItems}
      isDisabled={isDisabled}
      label={label}
      selectFunctionSelectableItems={selectUsers}
      selectFunctionSelectedItems={selectUsers}
      onChange={onChange}
      onSaveSelection={onSaveSelection}
      onSelectedItemClick={onSelectedItemClick}
    />
  );
};
